import React from 'react'
import clsx from 'clsx'

import AvatarGroup from '../../../molecules/AvatarGroup'
import MediaAvatar from '../../../atoms/MediaAvatar'
import Spacer from '../../../atoms/Spacer'

import { useSocket } from '../../../../providers/SocketProvider'
import useStyles from './styles'

type UserResultProps = {
  user: APIUser
  setSelected: React.Dispatch<React.SetStateAction<APIUser[]>>
  setRef: React.MutableRefObject<boolean>
  resetSearch: CallableFunction
}

const UserResult: React.FC<UserResultProps> = ({
  user,
  setSelected,
  setRef,
  resetSearch
}) => {
  const {
    peerChat: { addAgent }
  } = useSocket()

  const classes = useStyles()

  const handleClick = React.useCallback(() => {
    setSelected([user])
    setRef.current = false
    addAgent(user)
    resetSearch()
  }, [user, setSelected, setRef, addAgent, resetSearch])

  return (
    <div className={classes.holder}>
      <div className={classes.root} onClick={handleClick}>
        <div className={classes.type} />

        <div
          onClick={e => e.stopPropagation()}
          className={classes.avatarHolder}
        >
          {/* @ts-ignore */}
          <AvatarGroup>
            <MediaAvatar user={user} showBadge group />
          </AvatarGroup>
        </div>

        <div className={classes.contentRoot}>
          <div className={classes.contentBlock}>
            <div className={classes.contentTitle}>
              <div className={classes.contentName}>
                <div
                  className={clsx(
                    classes.contentName,
                    user.deleted_at && classes.contentFaded
                  )}
                >
                  {user?.deleted_at ? 'Deleted Contact' : user.name}
                </div>
              </div>

              <Spacer />
            </div>

            <div className={classes.content}>Chat with {user.name}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserResult
